import React from "react";
import InternalHeader from "~/components/Layout/components/InternalHeader";
import { useLang } from "~/hooks/useLang";
import ListAllAuditUserActionsReport from "./components/ListAllAuditUserActionsReport";

export default function AuditUserActionsReportTable() {
    const { translate } = useLang();
    
    

    return (
        <>
            <InternalHeader title={`${translate('Audit')}: ${translate('Reports')}`} />
            <ListAllAuditUserActionsReport />
        </>
    )
}